import { Component, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Workflows } from "src/providers/workflows/workflows";
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

import { Util } from 'src/shared/util/util';

import { ActiveIntegrationsPage } from 'src/pages/integrations/active-integrations/active-integrations';

@Component({
    templateUrl: 'workflow-template.html',
    standalone: false
})

export class WorkflowTemplatePage implements OnInit {

  template: any;
  isRightSideContent: boolean;  

  
  boundAddTemplate = this.addTemplate.bind(this);

constructor(
    private storage: TidyStorage,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private workflowsProvider: Workflows,
    private util: Util
  ) {}

  async ngOnInit() {
    const dialogParams = this.navCtrl.getParam('dialogParams') || await this.storage.retrieve('dialog-params');
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Add Workflow');
    this.template = this.navCtrl.getParam('workflowTemplate') || dialogParams.workflowTemplate;
  }

  async addTemplate() {
    try {
      const payload = {
        workflow_template_id: this.template.id
      }
      await this.workflowsProvider.addWorkflowTemplate(payload);
      this.rightSidePanelService.navigateTo('active-integrations', {}, ActiveIntegrationsPage);
      this.util.showSuccess('Template Added!');
    } catch (err) {
      this.util.showError(err.error && err.error.message ? err.error.message : err.message);
    }
  }

}
